import {
  IS_ACTIVE,
  CHANGE_SEARCH,
  UPDATE_REALTY_OFFERS,
  UPDATE_REALTY_OFFERS_PRIMARY,
  UPDATE_INPUT_INTERVALS_PRIMARY,
  CLEAR_FILTERS_PRIMARY,
  SET_LAUNCHING_YEARS,
  SET_CONSTRUCTION_PATTERN,
  SET_STATUS,
  UPDATE_BUILDING_DATA,
  UPDATE_REQUEST_STATUS,
  UPDATE_DISPLAY_PRIMARY_CHARTS,
  SET_INFOWINDOWS_PRIMARY,
  ADD_INFOWINDOWS_PRIMARY,
  REMOVE_ALL_INFOWINDOWS_PRIMARY,
  CLOSE_INFOWINDOWS_PRIMARY,
  SET_FILTERED_BUILDINGS,
  SET_FILTERED_COMPANIES,
  UPDATE_DISPLAY_BIG_NUMBERS_PRIMARY,
  SET_DISPLAY_GENERAL_CHARTS,
  UPDATE_CHARTS_DATA_PRIMARY,
  STORE_CHART_DATA,
  CLEAR_STORAGED_CHART_DATA_PRIMARY,
} from './offersPrimary.actions';

const realtyOffersFiltersOptionsGeneral = {
  launchingYears: [],
  realtyTypes: [
    { name: 'Apartamento', id: 'ap' },
    { name: 'Casa', id: 'cs' },
    { name: 'Comercial', id: 'comm' },
  ],
  privateAreaInterval: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  valueInterval: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  bedrooms: [
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    {
      name: '2',
      selected: false,
    },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  unitPrice: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  realtyAge: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
};

const initialFiltersPrimary = {
  realtyType: { name: 'Apartamento', id: 'ap' },
  inputIntervals: {
    privateAreaInterval: { min: '', max: '' },
  },
  bedrooms: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    {
      name: '2',
      selected: false,
    },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
};

const initialState = {
  realtyOffersFiltersOptionsGeneral,
  realtyOffersPrimaryGeneral: initialFiltersPrimary,
  userInput: {
    building: '',
    company: '',
  },
  buildingData: {},
  requestStatus: {
    launchedUnits: 'INACTIVE',
    launchedUnitsEcoMapPercentile: 'INACTIVE',
    sales: 'INACTIVE',
    harvest: 'INACTIVE',
    releasesSalesStock: 'INACTIVE',
    salesEcoMap: 'INACTIVE',
    weightedAverage: 'INACTIVE',
    weightedAverageEcoMap: 'INACTIVE',
    releasesSalesStockECOMAP: 'INACTIVE',
  },
  displayGeneralCharts: true,
  chartsDataPrimary: {
    infoWindowsPrimary: [],
    filteredBuildings: [],
    filteredCompanies: [],
    eco_map: [],
    sales: [],
    launchedUnits: [],
    launchedUnitsSales: [],
    percentileOffers: [],
    releasesSalesStock: [],
    weightedAverage: [],
    weightedAverageEcoMap: [],
    salesEcoMap: [],
    releasesSalesStockECOMAP: [],
  },
  primaryChartData: null,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case IS_ACTIVE:
      return {
        ...state,
        isActive: { ...state.isActive, [payload.name]: payload.value },
      };
    case CHANGE_SEARCH:
      return {
        ...state,
        userInput: { ...state.userInput, [payload.name]: payload.value },
      };
    case UPDATE_REALTY_OFFERS:
      return {
        ...state,
        realtyOffers: { ...state.realtyOffers, [payload.name]: payload.value },
      };
    case UPDATE_REALTY_OFFERS_PRIMARY:
      return {
        ...state,
        realtyOffersPrimaryGeneral: {
          ...state.realtyOffersPrimaryGeneral,
          [payload.name]: payload.value,
        },
      };
    case UPDATE_INPUT_INTERVALS_PRIMARY:
      return {
        ...state,
        realtyOffersPrimaryGeneral: {
          ...state.realtyOffersPrimaryGeneral,
          inputIntervals: {
            ...state.realtyOffersPrimaryGeneral.inputIntervals,
            [payload.name]: payload.value,
          },
        },
      };
    case CLEAR_FILTERS_PRIMARY:
      return {
        ...state,
        realtyOffersPrimaryGeneral: {
          ...initialFiltersPrimary,
          inputIntervals: {
            privateAreaInterval: { min: '', max: '' },
            pricePerSquareMt: { min: '', max: '' },
            unitPrice: { min: '', max: '' },
          },
        },
      };
    case SET_LAUNCHING_YEARS:
      return {
        ...state,
        realtyOffersFiltersOptionsGeneral: {
          ...state.realtyOffersFiltersOptionsGeneral,
          launchingYears: payload,
        },
      };
    case SET_CONSTRUCTION_PATTERN:
      return {
        ...state,
        realtyOffersFiltersOptionsGeneral: {
          ...state.realtyOffersFiltersOptionsGeneral,
          constructionPattern: payload,
        },
      };
    case SET_STATUS:
      return {
        ...state,
        realtyOffersFiltersOptionsGeneral: {
          ...state.realtyOffersFiltersOptionsGeneral,
          status: payload,
        },
      };
    case UPDATE_BUILDING_DATA:
      return { ...state, buildingData: { ...state.buildingData, ...payload } };
    case UPDATE_REQUEST_STATUS:
      return {
        ...state,
        requestStatus: {
          ...state.requestStatus,
          [payload.name]: payload.value,
        },
      };
    case UPDATE_DISPLAY_PRIMARY_CHARTS:
      return { ...state, displayPrimaryCharts: payload };
    case UPDATE_DISPLAY_BIG_NUMBERS_PRIMARY:
      return { ...state, displayBigNumbersPrimary: payload };
    case SET_INFOWINDOWS_PRIMARY:
      return { ...state, infoWindowsPrimary: [payload] };
    case ADD_INFOWINDOWS_PRIMARY:
      return {
        ...state,
        infoWindowsPrimary: [...state.infoWindowsPrimary, payload],
      };
    case REMOVE_ALL_INFOWINDOWS_PRIMARY:
      return { ...state, infoWindowsPrimary: [] };
    case CLOSE_INFOWINDOWS_PRIMARY:
      state.infoWindowsPrimary?.forEach((iw) => iw.close());
      return state;
    case SET_FILTERED_BUILDINGS:
      return { ...state, filteredBuildings: payload };
    case SET_FILTERED_COMPANIES:
      return { ...state, filteredCompanies: payload };
    case SET_DISPLAY_GENERAL_CHARTS:
      return { ...state, displayGeneralCharts: payload };
    case UPDATE_CHARTS_DATA_PRIMARY:
      return {
        ...state,
        chartsDataPrimary: {
          ...state.chartsDataPrimary,
          [payload.name]: payload.value,
        },
      };
    case STORE_CHART_DATA:
      return { ...state, primaryChartData: payload };
    case CLEAR_STORAGED_CHART_DATA_PRIMARY:
      return {
        ...state,
        primaryChartData: null,
      };
    default:
      return state;
  }
}
